// extracted by mini-css-extract-plugin
export default {"KeyGiverDropsStatsView":"KeyGiverDropsStatsView_KeyGiverDropsStatsView__+tv6W","select":"KeyGiverDropsStatsView_select__Z7Pye"};